import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from '../../../middlewares/api/actions';
import _ from 'lodash';
import {
  NODES_CONFIG_CONFIG_CHANGE,
  NODES_CONFIG_CONFIG_READ,
  NODES_CONFIG_MSD_SET,
  NODES_CONFIG_MSD_UNSET,
  NODES_CONFIG_MSDS_HIDE,
  NODES_CONFIG_MSDS_READ,
  NODES_CONFIG_MSDS_SHOW,
  NODES_CONFIG_NEW_NODE_REMOVE,
  NODES_CONFIG_NODE_ADD,
  NODES_CONFIG_NODE_CHECK_ENDPOINT_DM,
  NODES_CONFIG_NODE_CHECK_ENDPOINT_MA,
  NODES_CONFIG_NODE_CHECK_ENDPOINT_MD,
  NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI,
  NODES_CONFIG_NODE_COLLAPSED_CHANGE,
  NODES_CONFIG_NODE_REMOVE,
  NODES_CONFIG_NODE_SORT,
  NODES_CONFIG_DEFAULT_CONFIG_READ,
  NODES_CONFIG_GET_ICONS,
  NODE_CONFIG_COLORS
} from "./actions";
import {NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE} from "./node/GeneralForm";
import {
  NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP,
  NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME
} from "./node/EndpointForm";
import {
  getArtefactFromSdmxJsonStructure,
  getSdmxStructuresFromSdmxJson
} from "../../../utils/sdmxJson";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import { defaultAnnotations} from './node/annotations/constants';

// const getDictionaryFromLangs = (langs, str) =>
//   langs.map(({code}) => code).reduce((ac, a) => ({...ac, [a]: str}), {});

const nodesConfigReducer = (
  state = {
    config: null,
    configBeforeSort: null,
    isMsdsVisible: false,
    msds: null,
    nodeIndex: null,
    defaultConfig: null,
    icons: null,
    colors: null
  },
  action
  ) => {
    switch (action.type) {
      case NODES_CONFIG_NODE_ADD:
        return {
          ...state,
          config: [
            ...state.config,
            {
              isNewNode: true,
              isCollapsed: false,
              isNSIPingOk: null,
              isMAPingOk: null,
              isDMPingOk: null,
              isMDPingOk: null,
              General: {
                DefaultItemsViewMode: NODES_CONFIG_NODE_GENERAL_ITEMS_VIEW_MODE_TABLE,
                canViewUnallowedBuilderNodes: false,
                Invisible: false
              },
              Agencies: state.defaultConfig.Agencies || [],
              Endpoint: {
                PingArtefact: NODES_CONFIG_NODE_ENDPOINT_PING_ARTEFACT_CONCEPT_SCHEME,
                NSIEndpointType: NODES_CONFIG_NODE_ENDPOINT_NSI_ENDPOINT_TYPE_SOAP,
                Crypted: state.defaultConfig.Endpoint.Crypted
              },
              AnnotationTabs: {
                IsTextCollapsed: true,
                Tabs: []
              },
              Annotations: _.merge(defaultAnnotations, state.defaultConfig.Annotations || {}), 
              Search: {
                ExcludeCodelists: state.defaultConfig.ExcludeCodelists || [], 
                ExcludeConceptSchemes: state.defaultConfig.ExcludeConceptSchemes || [],
              },
              Proxy: {
                Enabled: false
              },
              DataBrowser: {
                Enable: false,
                HTTPAuthEnable: false,
                ProxyEnable: false
              },
              DcatApIt: {
                MSD: null
              },
              Plugins:[]
            }
          ]
        };
      case NODES_CONFIG_NEW_NODE_REMOVE: {

        let config = _.cloneDeep(state.config);

        config.splice(action.nodeIndex, 1);

        return {
          ...state,
          config
        };
      }
      case NODES_CONFIG_CONFIG_CHANGE:

        const initialDataBrowserCacheFields = {
          URL: "",
          Username: "",
          Password: "",
          HTTPAuthEnable: false,
          HTTPAuthUsername: "",
          HTTPAuthPassword: "",
          HTTPAuthDomain: "",
          ProxyEnable: false,
          ProxyURL: "",
          ProxyPort: "",
          ProxyUsername: "",
          ProxyPassword: ""
        };

        return {
          ...state,
          config: action.config.map(node => ({
            ...node,
            isNSIPingOk: null,
            isMAPingOk: null,
            isDMPingOk: null,
            isMDPingOk: null,
            DataBrowser: {
              ...node.DataBrowser,
              ...(node.DataBrowser.Enable ? {} : initialDataBrowserCacheFields)
            }
          }))
        };
      case NODES_CONFIG_NODE_COLLAPSED_CHANGE: {

        const config = _.cloneDeep(state.config);

        return {
          ...state,
          config: config.map((node, index) => ({
            ...node,
            isCollapsed:
              action.nodeIndex === index
                ? action.collapsed
                : node.isCollapsed
          }))
        };
      }
      case NODES_CONFIG_MSDS_SHOW:
        return {
          ...state,
          isMsdsVisible: true,
          nodeIndex: action.nodeIndex
        };
      case NODES_CONFIG_MSDS_HIDE:
        return {
          ...state,
          isMsdsVisible: false,
          msds: null,
          nodeIndex: null
        };
      case NODES_CONFIG_MSD_SET:
        return {
          ...state,
          isMsdsVisible: false,
          msds: null,
          nodeIndex: null,
          config: state.config.map((node, index) => {
            if (index === state.nodeIndex) {
              node.DcatApIt.MSD = action.msd;
            }
            return node
          })
        };
      case NODES_CONFIG_MSD_UNSET:
        return {
          ...state,
          config: state.config.map((node, index) => {
            if (index === action.nodeIndex) {
              node.DcatApIt.MSD = null;
            }
            return node
          })
        };
      case NODES_CONFIG_NODE_CHECK_ENDPOINT_MD:
        const config = _.cloneDeep(state.config);

        return {
          ...state,
          config: config.map((node, index) => ({
            ...node,
            isMDPingOk:
              action.nodeIndex === index
                ? action.requestSuccess
                : node.isMDPingOk
          }))
        };
      case REQUEST_START:
        switch (action.label) {
          case NODES_CONFIG_NODE_SORT: {
            return {
              ...state,
              config: action.orderedNodes,
              configBeforeSort: state.config,
            };
          }
          case NODES_CONFIG_GET_ICONS:{
            return {
              ...state,
              icons:null
            }
          }
          case NODE_CONFIG_COLORS:{
            return {
              ...state,
              colors: null
            }
          }
          default:
            return state;
        }
      case REQUEST_ERROR:
        switch (action.label) {
          case NODES_CONFIG_NODE_SORT: {
            return {
              ...state,
              config: state.configBeforeSort,
              configBeforeSort: null
            };
          }
          case NODES_CONFIG_GET_ICONS:{
            return {
              ...state,
              icons: null
            }
          }
          case NODE_CONFIG_COLORS:{
            return {
              ...state,
              colors: null
            }
          }
          default:
            return state;
        }
      case REQUEST_SUCCESS:
        switch (action.label) {
          case NODES_CONFIG_CONFIG_READ: {
            const nodes = action.response || [];
            Object.keys(state.defaultConfig.Annotations || {}).forEach(ann => {
              nodes.forEach(node => {
                const annotations = node.Annotations || {};
                if (!annotations[ann]) {
                  annotations[ann] = {
                    "Id": "",
                    "Type": ""
                  }
                }
                node.Annotations = annotations;
              })
            });
            return {
              ...state,
              config: nodes.map(node => ({
                ...node,
                isCollapsed: true,
                isNSIPingOk: null,
                isMAPingOk: null,
                isDMPingOk: null,
                isMDPingOk: null,
                DataBrowser: {
                  Enable: false,
                  HTTPAuthEnable: false,
                  ProxyEnable: false,
                  ...node.DataBrowser
                }
              })),
              configBeforeSort: null
            };
          }            
          case NODES_CONFIG_NODE_REMOVE: {
            let config = _.cloneDeep(state.config);
            config.splice(action.nodeIndex, 1);
            return {
              ...state,
              config
            };
          }
          case NODES_CONFIG_NODE_CHECK_ENDPOINT_NSI: {
            const config = _.cloneDeep(state.config);

            return {
              ...state,
              config: config.map((node, index) => ({
                ...node,
                isNSIPingOk:
                  action.nodeIndex === index
                    ? action.response
                    : node.isNSIPingOk
              }))
            };
          }
          case NODES_CONFIG_NODE_CHECK_ENDPOINT_MA: {
            const config = _.cloneDeep(state.config);

            return {
              ...state,
              config: config.map((node, index) => ({
                ...node,
                isMAPingOk:
                  action.nodeIndex === index
                    ? action.response
                    : node.isMAPingOk
              }))
            };
          }
          case NODES_CONFIG_NODE_CHECK_ENDPOINT_DM: {
            const config = _.cloneDeep(state.config);

            return {
              ...state,
              config: config.map((node, index) => ({
                ...node,
                isDMPingOk:
                  action.nodeIndex === index
                    ? action.response
                    : node.isDMPingOk
              }))
            };
          }
          case NODES_CONFIG_MSDS_READ:
            return {
              ...state,
              msds: (getSdmxStructuresFromSdmxJson(action.response) || []).map(msd =>
                getArtefactFromSdmxJsonStructure(msd, getCurrentNodeConfig(action).annotations))
            };
          case NODES_CONFIG_DEFAULT_CONFIG_READ : {
            const defaultConfig = action.response || {};
            defaultConfig.Annotations = _.merge(defaultAnnotations, defaultConfig.Annotations);
            return {
              ...state,
              defaultConfig: defaultConfig
            }
          }
          case NODES_CONFIG_GET_ICONS:{
            return {
              ...state,
              icons: action.response
            }
          }
          case NODE_CONFIG_COLORS:{
            return {
              ...state,
              colors:action.response
            }
          }
          default:
            return state;
        }
      default:
        return state;
    }
  }
;

export default nodesConfigReducer;
